// export.ts — CSV export of mood entries, built entirely client-side.
// Replaces the archived Flutter /api/export/csv path — now built client-side.

import type { MoodEntry } from "./store";
import { labelForScore } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, Score, Mood, Note, Tags. */
export function entriesCsv(entries: MoodEntry[]): string {
  return csv(
    ["Date", "Score", "Mood", "Note", "Tags"],
    entries.map((e) => [e.logged_on, e.score, labelForScore(e.score), e.note ?? "", e.tags.join(" ")]),
  );
}

export function buildExport(entries: MoodEntry[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: entriesCsv(entries), filename: `mood-entries-${stamp}.csv` };
}
